import { ContactClassificationStatus } from '@/models/ContactClassificationStatus';

/**
 * The label of a classification status, so every screen names a status the same way.
 */
export const getClassificationStatusLabel = (
  status: ContactClassificationStatus,
  t: (key: string) => string
): string => {
  switch (status) {
    case ContactClassificationStatus.PendingApproval:
      return t('statusPendingApproval');
    case ContactClassificationStatus.Approved:
      return t('statusApproved');
    case ContactClassificationStatus.Rejected:
      return t('statusRejected');
    case ContactClassificationStatus.PendingCompletion:
      return t('statusPendingCompletion');
    case ContactClassificationStatus.Cancelled:
      return t('statusCancelled');
    case ContactClassificationStatus.CompletionReturned:
      return t('statusCompletionReturned');
    default:
      return status;
  }
};
